import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import {
  getListCandidateCampaignFailed,
  getListCandidateCampaignStart,
  getListCandidateCampaignSuccess,
} from "../redux/getList";
import { getCVCampaignApi } from "core/http/service/evaluation";

function* getListCandidateCampaignWork(
  action: ReturnType<typeof getListCandidateCampaignStart>
) {
  const screenCode = action.payload?.screenCode;
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector("candidateCampaign")
  );

  const params = {
    offset,
    limit,
  };

  try {
    const res = yield call(getCVCampaignApi, { screenCode, ...params });
    yield put({
      type: getListCandidateCampaignSuccess.type,
      payload: {
        data: res.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListCandidateCampaignFailed.type,
    });
  }
}

function* watchGetListCandidateCampaign() {
  yield takeLatest(
    getListCandidateCampaignStart.type,
    getListCandidateCampaignWork
  );
}

export default function* getListCandidateCampaignSaga() {
  yield all([watchGetListCandidateCampaign()]);
}
